import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';

const ValidationCriteriaComponent = ({ isValid, text }) => {
    const styles = {
        criteriaList: {
            listStyleType: 'none',
            padding: 0,
            marginTop: '10px'
        },
        criterion: {
            marginBottom: '5px',
            fontSize: '0.9em'
        },
        valid: {
            color: 'green'
        },
        invalid: {
            color: 'red'
        }
    };
    return (
        <li style={{ ...styles.criterion, ...(isValid ? styles.valid : styles.invalid) }}>
            {isValid ? '✅' : '❌'} {text}
        </li>
    );
};

ValidationCriteriaComponent.displayName = 'ValidationCriteria';

const ValidationCriteria = (props) => {
    return (
        <ErrorWrapper>
            <ValidationCriteriaComponent
                data-id="ValidationCriteria-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default ValidationCriteria;
